export const namespace = 'journeys';
